import { render } from "./StuckWorkWarningProvider.vue?vue&type=template&id=35aac307"
import script from "./StuckWorkWarningProvider.vue?vue&type=script&lang=js"
export * from "./StuckWorkWarningProvider.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__